(function (root, factory) {
  if (root.FBPersonNotes) return;
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  root.FBPersonNotes = api;
  if (root.document && typeof root.document.querySelectorAll === 'function') api.boot(root.document);
})(typeof window !== 'undefined' ? window : globalThis, function () {
  'use strict';

  /* The factory is not nested in the loader, so the loader's `root`
     argument is not in scope here. Capture the global explicitly. */
  var root = typeof window !== 'undefined' ? window : globalThis;

  /* Product-owned conflict list for Reminders person notes, phase 1.
     business-os #144. A soft prompt only — never a checkout block, and
     never a claim that a design is allergy-safe. */
  var DRAWER_LIMIT = 800;
  var FULFILMENT_LIMIT = 500;
  var PREVIEW_LIMIT = 120;
  var ATTRIBUTE = '_fb_person_notes';
  var STASH_KEY = 'fb_rem_person_notes';
  var CTX_KEY = 'fb_rem_ctx';
  var KEYWORDS = ['lily', 'lilies', 'natives', 'pet', 'pets', 'cats', 'dogs', 'scent', 'fragrance', 'newborn', 'baby'];
  var EMPTY_ROW = 'Add a note — allergies, pets, colours, what they said last time.';
  var BANNER_COPY = 'You saved personal notes for this person. Check this still suits them before you send. We use them to choose well — we never guarantee allergy-safe designs.';

  function containsKeyword(text) {
    var hay = String(text == null ? '' : text).toLowerCase();
    return KEYWORDS.some(function (word) {
      return new RegExp('(^|[^a-z0-9])' + word + '([^a-z0-9]|$)').test(hay);
    });
  }

  function productBlob(product) {
    if (!product) return '';
    var tags = product.tags;
    if (Array.isArray(tags)) tags = tags.join(' ');
    return [product.title, tags, product.blurb, product.description].filter(function (part) {
      return part != null && String(part) !== '';
    }).join('\n');
  }

  /* Phase 1: person context has non-empty notes, and the product
     title, tags or blurb hits a keyword. Notes do not have to repeat
     the same word — the prompt is a check, not a medical rule. */
  function conflicts(notesText, product) {
    if (!String(notesText == null ? '' : notesText).trim()) return false;
    return containsKeyword(productBlob(product));
  }

  function anyConflict(notesText, products) {
    return (products || []).some(function (product) { return conflicts(notesText, product); });
  }

  function drawerError(text) {
    if (String(text == null ? '' : text).length > DRAWER_LIMIT) return 'Personal notes can be up to 800 characters.';
    return '';
  }

  function fulfilmentNotes(text) {
    var value = String(text == null ? '' : text).trim();
    if (!value) return '';
    return value.length <= FULFILMENT_LIMIT ? value : value.slice(0, FULFILMENT_LIMIT);
  }

  function preview(text) {
    var value = String(text == null ? '' : text).trim().replace(/\s+/g, ' ');
    if (!value) return '';
    return value.length <= PREVIEW_LIMIT ? value : value.slice(0, PREVIEW_LIMIT).trimEnd() + '…';
  }

  function rowPreview(text) {
    var value = preview(text);
    return value ? value + ' Edit' : EMPTY_ROW;
  }

  /* Same body the Club person page already PATCHes. The details API
     accepts one key at a time; sending notesText beside notes is a 400
     ("Save one set of details at a time."). */
  function detailsBody(text, version) {
    return { notes: { text: String(text == null ? '' : text), version: version } };
  }

  function notesFromDetails(payload) {
    var details = payload && payload.details;
    var notes = details && details.notes;
    if (notes && (typeof notes.text === 'string' || notes.version != null)) {
      return { text: typeof notes.text === 'string' ? notes.text : '', version: notes.version };
    }
    if (details && typeof details.notesText === 'string') {
      return { text: details.notesText, version: details.notesVersion != null ? details.notesVersion : null };
    }
    if (payload && typeof payload.notesText === 'string') {
      return { text: payload.notesText, version: payload.notesVersion != null ? payload.notesVersion : null };
    }
    return { text: '', version: null };
  }

  /* Null means attach nothing: no person context, or notes are empty.
     The returned object is only the cart attribute — never cart.note. */
  function attributesForCart(context) {
    if (!context || (!context.ctx && !context.friendId)) return null;
    var notes = fulfilmentNotes(context.notesText);
    if (!notes) return null;
    var attributes = {};
    attributes[ATTRIBUTE] = notes;
    return attributes;
  }

  function readNotes(storage) {
    try {
      var context = JSON.parse((storage && storage.getItem(CTX_KEY)) || 'null');
      if (!context || (!context.ctx && !context.friendId)) return '';
      return typeof context.notesText === 'string' ? context.notesText : '';
    } catch (_) { return ''; }
  }

  function dismissKey(notes, products) {
    var titles = (products || []).map(function (product) { return product && product.title || ''; }).join('|');
    return 'fb_person_notes_dismiss:' + String(notes || '').slice(0, 80) + ':' + titles.slice(0, 180);
  }

  function readProducts(container) {
    var node = container.querySelector('[data-fb-person-notes-products]');
    if (!node) return [];
    try {
      var parsed = JSON.parse(node.textContent || '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch (_) { return []; }
  }

  function mountPrompt(container, env) {
    if (!container) return { shown: false };
    env = env || {};
    var doc = env.document || root.document;
    var storage = env.storage || root.sessionStorage;
    var products = env.products || readProducts(container);
    var notes = env.notesText != null ? env.notesText : readNotes(storage);
    var key = dismissKey(notes, products);
    var dismissed = false;
    try { dismissed = !!(storage && storage.getItem(key) === '1'); } catch (_) {}
    var show = !dismissed && anyConflict(notes, products);
    container.hidden = !show;
    if (!show) return { shown: false };
    var copy = container.querySelector('[data-fb-person-notes-copy]');
    if (copy) copy.textContent = BANNER_COPY;
    var dismiss = container.querySelector('[data-fb-person-notes-dismiss]');
    if (dismiss) {
      dismiss.type = 'button';
      if (dismiss.getAttribute('data-fb-person-notes-bound') !== '1') {
        dismiss.setAttribute('data-fb-person-notes-bound', '1');
        dismiss.addEventListener('click', function (event) {
          if (event && event.preventDefault) event.preventDefault();
          try { if (storage && storage.setItem) storage.setItem(key, '1'); } catch (_) {}
          var nodes = doc && doc.querySelectorAll ? doc.querySelectorAll('[data-fb-person-notes-prompt]') : [container];
          for (var i = 0; i < nodes.length; i++) nodes[i].hidden = true;
        });
      }
    }
    return { shown: true };
  }

  function boot(doc) {
    doc = doc || root.document;
    if (!doc || typeof doc.querySelectorAll !== 'function' || doc.__fbPersonNotesBooted) return;
    doc.__fbPersonNotesBooted = true;
    function mountAll() {
      var nodes = doc.querySelectorAll('[data-fb-person-notes-prompt]');
      for (var i = 0; i < nodes.length; i++) mountPrompt(nodes[i], { document: doc });
    }
    if (doc.readyState === 'loading' && typeof doc.addEventListener === 'function') doc.addEventListener('DOMContentLoaded', mountAll);
    else mountAll();
    if (typeof doc.addEventListener === 'function') {
      doc.addEventListener('cart:updated', mountAll);
      doc.addEventListener('fb-person-notes:updated', mountAll);
    }
  }

  return {
    DRAWER_LIMIT: DRAWER_LIMIT,
    FULFILMENT_LIMIT: FULFILMENT_LIMIT,
    PREVIEW_LIMIT: PREVIEW_LIMIT,
    ATTRIBUTE: ATTRIBUTE,
    STASH_KEY: STASH_KEY,
    KEYWORDS: KEYWORDS,
    EMPTY_ROW: EMPTY_ROW,
    BANNER_COPY: BANNER_COPY,
    containsKeyword: containsKeyword,
    conflicts: conflicts,
    anyConflict: anyConflict,
    drawerError: drawerError,
    fulfilmentNotes: fulfilmentNotes,
    preview: preview,
    rowPreview: rowPreview,
    detailsBody: detailsBody,
    notesFromDetails: notesFromDetails,
    attributesForCart: attributesForCart,
    readNotes: readNotes,
    mountPrompt: mountPrompt,
    boot: boot
  };
});
